<ion-header [translucent]="true">
	<ion-toolbar>
		<ion-title
			><span class="highlight">{{ 'giftCard.title' | translate }}</span
			><br
		/></ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="close()" fill="clear">
				<ion-icon name="close"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<div class="giftcard-container">
		<ion-item>
			<ion-label position="stacked">{{ 'giftCard.codeLabel' | translate }}</ion-label>
			<ion-input
				(ionChange)="giftCard = null"
				[(ngModel)]="giftCardCode"
				[disabled]="loading"
				[placeholder]="'giftCard.codePlaceholder' | translate"
			></ion-input>
		</ion-item>

		<ion-button (click)="checkGiftCard()" [disabled]="loading || !giftCardCode.trim()" class="check-btn" expand="block">
			{{ 'giftCard.checkBalance' | translate }}
		</ion-button>
		@if (loading) {
			<ion-spinner name="crescent"></ion-spinner>
		}

		@if (giftCardError) {
			<ion-text class="error-message" color="danger">
				<p>{{ giftCardError }}</p>
			</ion-text>
		}

		@if (!giftCardError && giftCard) {
			<div class="balance-info">
				<ion-text color="success">
					<h3>{{ 'giftCard.availableBalance' | translate }}</h3>
					<h2 class="balance-amount">{{ formattedGiftCardBalance }}</h2>
				</ion-text>
			</div>
		}
	</div>
</ion-content>

<ion-footer class="ion-padding">
	<!-- Tip Selector -->
	<!--<app-tip-selector
		(tipChange)="selectTip($event)"
		[itemCount]="paySessionStatistics?.selectedProductsCount ?? 0"
		[selectedTip]="selectedTip"
		[totalPrice]="paySessionStatistics?.selectedTotalPrice ?? 0"
	></app-tip-selector> -->

	<!-- Submit Button -->
	<ion-button (click)="confirmButton()" [disabled]="!isValid" class="pay-btn" expand="block"> {{ 'common.add' | translate }}</ion-button>
</ion-footer>
